import { makeStyles, makeResetStyles, tokens } from "@fluentui/react-components";

export const useSheetOptionStyles = makeStyles({
  inputcheckbox: {
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  input: {
    paddingLeft: "17px",
    paddingRight: "10px",
  },
  dividerPT: {
    paddingLeft: "17px",
    paddingRight: "10px",
    paddingTop: "5px",
    paddingBottom: "5px",
  },
  card: {
    width: "100%",
    maxWidth: "100%",
    height: "100%",
  },
  cardPreview: {
    height: "340px",
  },
  cardFooter: {
    textAlign: "right",
  },
  root: {
    textAlign: "center",
    marginRight: "10px",
    marginLeft: "10px",
    paddingTop: "10px",
  },
  button: {
    width: "85px",
  },
  ErrorButton: {
    marginRight: "20px",
    backgroundColor: "#0078D4",
    color: "#f7f8fa",
    width: "100%",
  },
  noteContainer: {
    paddingTop: "10px",
  },
});

export const useStackClassName = makeResetStyles({
  display: "flex",
  flexDirection: "column",
  rowGap: tokens.spacingVerticalL,
});
